import axios from "axios";

export const zohoInitAuth = async (companyId: string) => {
    try {
        const res: any = await axios.get(`/integrations/zoho/auth?companyId=${companyId}`);
        return res?.data; 
    } catch (e: any) {
        return e?.response?.data ? e.response.data : e;
    }
}

export const resyncZohoClients = async (companyId: string) => {
    try {
        const res: any = await axios.post(`/integrations/zoho/sync-clients`);
        return res?.data; 
    } catch (e: any) {
        return e?.response?.data ? e.response.data : e;
    }
}

export const reconcieZohoClients = async (sourceOfTruth: string) => {
    try {
        const res: any = await axios.post(`/integrations/zoho/reconcile`, { sourceOfTruth });
        return res?.data; 
    } catch (e: any) {
        return e?.response?.data ? e.response.data : e;
    }
}

export const resyncProviders = async () => {
    try {
        const res: any = await axios.get(`/integrations/zoho/providers/analyze`);
        return res?.data; 
    } catch (e: any) {
        return e?.response?.data ? e.response.data : e;
    }
}

export const resyncProjects = async () => {
    try {
        const res: any = await axios.get(`/integrations/zoho/projects/analyze`);
        return res?.data; 
    } catch (e: any) {
        return e?.response?.data ? e.response.data : e;
    }
}

export const resyncProductsAndServices = async () => {
    try {
        const res: any = await axios.get(`/integrations/zoho/items/analyze`);
        return res?.data; 
    } catch (e: any) {
        return e?.response?.data ? e.response.data : e;
    }
}

export const resyncPurchaseOrders = async () => {
    try {
        const res: any = await axios.get(`/integrations/zoho/purchase-orders/analyze`);
        return res?.data; 
    } catch (e: any) {
        return e?.response?.data ? e.response.data : e;
    }
}

export const resyncInvoices = async ({ dryRun = true }: { dryRun?: boolean } = {}) => {
    try {
        const res: any = await axios.post(`/integrations/zoho/invoices/resync`, {
            dryRun,
        });
        return res?.data;
    } catch (e: any) {
        return e?.response?.data ? e.response.data : e;
    }
}

export const getZohoIntegration = async (companyId: string) => {
    try {
        const res: any = await axios.get(`/integrations/zoho/integration?companyId=${companyId}`);
        return res?.data;
    } catch (e: any) {
        return e?.response?.data ? e.response.data : e;
    }
}

export const setZohoAutoSync = async (integrationId: string, autoSyncOn: boolean) => {
    try {
        const res: any = await axios.post(`/integrations/zoho/integration/auto-sync`, {
            integrationId,
            autoSyncOn,
        });
        return res?.data;
    } catch (e: any) {
        return e?.response?.data ? e.response.data : e;
    }
}
